import { alpha, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  comment: {
    padding: '5px',
    marginTop: '10px',
    '&:hover': {
      borderLeft: '5px solid rgb(63, 81, 181)',
    },
    borderLeft: '5px solid rgb(255, 255, 255)',
  },
  commentTypo: {
    paddingLeft: '50px',
    marginTop: '2px',
  },
  avatar: {
    margin: theme.spacing(1),
    marginTop: -5,
    width: 10,
    height: 10,
  },
  expansionPanel: {
    marginBottom: theme.spacing(1.25),
    borderRadius: 18,
    overflow: 'hidden',
    border: `1px solid ${alpha('#6366f1', 0.12)}`,
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 12px 28px rgba(15, 23, 42, 0.06)',
    transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
    '&:before': {
      display: 'none',
    },
    '&.MuiExpansionPanel-rounded:last-child': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    '&:hover': {
      transform: 'translateY(-1px)',
      borderColor: alpha('#2563eb', 0.2),
      boxShadow: '0 16px 32px rgba(37, 99, 235, 0.10)',
    },
  },
  expansionPanelSummary: {
    minHeight: 80,
    padding: theme.spacing(0, 2.5),
    background:
      'linear-gradient(135deg, rgba(239,246,255,0.82) 0%, rgba(255,255,255,0.96) 100%)',
    '& .MuiExpansionPanelSummary-content': {
      margin: theme.spacing(1.5, 0),
    },
    '& .MuiExpansionPanelSummary-expandIcon': {
      color: '#2563eb',
      padding: 6,
      borderRadius: 12,
      backgroundColor: 'rgba(37, 99, 235, 0.08)',
    },
  },
  expansionPanelDetail: {
    display: 'block',
    padding: theme.spacing(0, 2.5, 2.5),
  },
  summaryContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  activityMarker: {
    width: 42,
    height: 42,
    borderRadius: 14,
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
    color: '#2563eb',
    fontWeight: 700,
    fontSize: '0.9rem',
    background:
      'linear-gradient(135deg, rgba(37,99,235,0.14) 0%, rgba(99,102,241,0.12) 100%)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.7)',
  },
  activityHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.6),
    minWidth: 0,
  },
  activityTitle: {
    fontWeight: 700,
    color: '#0f172a',
    lineHeight: 1.25,
    wordBreak: 'break-word',
  },
  activityMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  subtaskBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.35, 1),
    borderRadius: 999,
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#4338ca',
    backgroundColor: 'rgba(99, 102, 241, 0.10)',
    border: `1px solid ${alpha('#6366f1', 0.14)}`,
  },
  activityDate: {
    fontSize: '0.76rem',
    color: '#64748b',
  },
  activityBody: {
    padding: theme.spacing(1.75, 2),
    borderRadius: 14,
    border: '1px solid rgba(148, 163, 184, 0.14)',
    backgroundColor: 'rgba(255,255,255,0.92)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.75)',
  },
}));

export default useStyles;
